import { fetchJson } from './../core/ajax-json.js';
import { push } from './../store/history.js';
import { disableRealityCheckDuration, resetRealityCheckDuration } from './reality-check.js';
import notifications from './../notifications.js';
import { setDesktopCookies, rootDomain } from './../store/cookies.js';
import Cookies from './../libs/tomcat-cookies.js';

let globalNotificationElem;
let checkRealityElem;

function hide() {
	checkRealityElem.classList.remove('notify--is-open');
	globalNotificationElem.classList.remove('global-notification--is-open');
}

function getShowHistoryClickHandler(texts) {
	return () => {
		hide();
		notifications.showConfirmationMessage('default-success',
			texts.historyTitle, texts.historyMessage, texts.historyLinkButton, () => {
				setDesktopCookies();
				Cookies.set('showMobileBanner', true, { domain: rootDomain() });
				window.location.href = texts.historyLink;
			}, texts.historyCloseButton, {
				closeCallback: () => {
					notifications.hideNotification();
					show();
				}
			});
	};
}

function logout() {
	hide();
	push('/logout');
}

function show() {
	const globalNotification = document.getElementsByClassName('js-global-notification');
	if (globalNotification && globalNotification.length > 0) {
		globalNotificationElem = globalNotification[0];
	} else {
		return;
	}
	checkRealityElem = globalNotificationElem.getElementsByClassName('js-reality-check')[0];

	globalNotificationElem.classList.add('global-notification--is-open');
	checkRealityElem.classList.add('notify--is-open');

	fetchJson('/player/limits/reality-check/popup')
		.then((response) => {
			const messageUpper = `${response.result.texts.messageUpper}. `;
			const playTime = `${response.result.playTimeHours} ${response.result.texts.hours}, ${response.result.playTimeMinutes} ${response.result.texts.minutes}, `;
			const betSum = `${response.result.betSum}`;
			checkRealityElem.getElementsByClassName('js-message-upper')[0].textContent = messageUpper;
			checkRealityElem.getElementsByClassName('js-play-time')[0].textContent = playTime;
			checkRealityElem.getElementsByClassName('js-bet-sum')[0].textContent = betSum;

			checkRealityElem.getElementsByClassName('js-continue-button')[0].textContent = response.result.texts.closeAndReset;
			checkRealityElem.getElementsByClassName('js-disable-button')[0].textContent = response.result.texts.closeAndDisable;
			checkRealityElem.getElementsByClassName('js-history-button')[0].textContent = response.result.texts.historyButton;
			checkRealityElem.getElementsByClassName('js-logout-button')[0].textContent = response.result.texts.logout;
			checkRealityElem.getElementsByClassName('js-history-button')[0].onclick = getShowHistoryClickHandler(response.result.texts);
		});

	checkRealityElem.getElementsByClassName('js-continue-button')[0].onclick = () => {
		resetRealityCheckDuration();
		hide();
	};
	checkRealityElem.getElementsByClassName('js-logout-button')[0].onclick = logout;
	checkRealityElem.getElementsByClassName('js-disable-button')[0].onclick = () => {
		disableRealityCheckDuration();
		hide();
	};
}

export default {
	show
};



// WEBPACK FOOTER //
// ./mobile-core/src/reality-check/reality-check-view.js